import { Component, OnInit } from '@angular/core';
import { BusinessService } from '../../../../common/services/Business.service';
import { SettingService } from '../../../../common/services/Setting.service';
import { UploadService } from '../../../../common/services/Upload.service';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { ToastrService } from 'ngx-toastr';
import { ImageService } from '../../../imageService';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: 'app-setting-active-product',
  templateUrl: 'setting-active-product.template.html',
  styleUrls: ['./business.css'],
  providers: [BusinessService, EvsAddressService, UploadService, ImageService, SettingService],
})
export class SettingActiveProductComponent implements OnInit {
  public data: any;

  constructor(
    private toastr: ToastrService,
    private settingService: SettingService,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.getList();
  }

  getList() {
    this.settingService.getDetailSettingActive().subscribe(
      (res: any) => {
        if (res.code == 1 && res.data) {
          this.data = res.data;
        } else {
          this.toastr.error(this.translate.instant('CO_LOI_XAY_RA'), this.translate.instant('THONG_BAO_COLON'), {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
        }
      },
      (err: any) => {
        this.toastr.error(err, this.translate.instant('THONG_BAO_COLON'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      }
    );
  }

  changeConfig(event, index: number) {
    const reassignValue = event.target.checked
    this.data[index] = {
      ...this.data[index],
      reassign: reassignValue
    }
    const body = {
      reassign: this.data[index].reassign,
      key: this.data[index].key
    }
    this.settingService.updateSettingActive(body).subscribe((res) => {
      if (res.code === 1) {
        this.toastr.success(this.translate.instant('THANH_CONG'), this.translate.instant('THONG_BAO_COLON'), {
          timeOut: 4000, positionClass: 'toast-bottom-right'
        })
        this.getList();
      }
    }, (err: any) => {
      this.toastr.success(err, this.translate.instant('THONG_BAO_COLON'), {
        timeOut: 4000, positionClass: 'toast-bottom-right'
      })
    })
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/setting-active-product.component.ts